<template>
	<modal body-classes="p-0" :show="open" @close="close">
		<card type="secondary" class="border-0 mb-0">
			<template slot="header">
				<h2 class="text-center mb-0">เพิ่มโบนัส</h2>
			</template>
			<template>
				<form @submit.prevent="addBonus">
					<base-input
						label="ชื่อโบนัส"
						placeholder="ชื่อโบนัส"
						required
						v-model="bonus.name"
					/>
					<base-input
						label="รายละเอียด"
						placeholder="รายละเอียด"
						required
						v-model="bonus.description"
					/>

					<div class="mt-1">
						<base-button
							native-type="submit"
							type="default"
							:disabled="loading"
						>
							บันทึกข้อมูล
						</base-button>
					</div>
				</form>
			</template>
		</card>
	</modal>
</template>

<script>
import { Select, Option } from 'element-ui'

import BonusService from '../../services/bonus.service'

export default {
	props: ['open'],
	components: {
		[Select.name]: Select,
		[Option.name]: Option,
	},
	data() {
		return {
			loading: false,
			bonus: {
				key: '',
				name: '',
				description: '',
				minimum: 0,
				minBonus: 0,
				maxBonus: 0,
				type: 'percent',
				gameType: '',
				amount: 0,
				turn: 0,
				maxWithdraw: 0,
				limit: 'once',
			},
		}
	},
	methods: {
		close() {
			this.$emit('close')
		},
		addBonus() {
			if (!this.bonus.key.match(/^[a-zA-Z0-9]+$/)) {
				this.$notify({
					type: 'danger',
					message: 'คีย์โบนัสต้องเป็นภาษาอังกฤษและตัวเลขเท่านั้น',
				})
				return false
			}

			this.loading = true
			BonusService.addBonus(this.bonus)
				.then(({ message }) => {
					this.$notify({
						type: 'success',
						message: message,
					})

					this.$emit('close')
					this.$emit('reload')
				})
				.catch(({ message }) => {
					this.$notify({ type: 'danger', message })
				})
				.finally(() => {
					this.loading = false
				})
		},
	},
	watch: {
		open(v) {
			if (v) {
				this.bonus.key =
					localStorage.getItem('x-prefix').toLowerCase() +
					Math.floor(Math.random() * 1000000000)
			}
		},
	},
}
</script>
